import type { TMember } from '@src/shared/types/member';
import type { TProgram } from '@src/shared/types/program';

export function isTProgram(item: unknown): item is TProgram {
  return (
    typeof item === 'object' &&
    item !== null &&
    typeof (item as TProgram).name === 'string'
  );
}

export function isTMember(item: unknown): item is TMember {
  return (
    typeof item === 'object' &&
    item !== null &&
    typeof (item as TMember).first_name === 'string' &&
    typeof (item as TMember).last_name === 'string'
  );
}
